<template>
  <div>
    <div class="step">
      <!-- 상단 페이지명, 스텝 -->
      <div class="top-wrap" flex fjb>
        <div class="step-title">
          {{ $t("Verification.step4.korean.title") }}
        </div>
        <div class="step-number" flex>
          <div class="number active">1</div>
          <div class="number active ml8">2</div>
          <div class="number active ml8">3</div>
          <div class="number active ml8">4</div>
        </div>
      </div>
      <!-- //상단 페이지명, 스텝 -->

      <!-- 하단 콘텐츠 -->
      <div v-if="data.oneForth" class="pt20">
        <div class="top-noti">
          <img
            src="../../../../../../assets/img/mypage/exclamation_mark_ic.svg"
            alt=""
            class="exclamation-mark"
          />
          {{ $t("Verification.step4.korean.description[0]") }}
          <span class="sub-color">
            {{ $t("Verification.step4.korean.description[1]") }}
          </span>
          {{ $t("Verification.step4.korean.description[2]") }}
        </div>

        <!-- 4-1 -->
        <div class="content mt12">
          <!-- 은행 선택 -->
          <div class="bank-wrap" flex>
            <div class="name">
              {{ $t("Verification.step4.korean.bank.title") }}
            </div>
            <el-select
              size="mini"
              v-model="data.bankMCode"
              :placeholder="$t('Verification.step4.korean.bank.description')"
              :disabled="data.success"
              class="bank-list"
            >
              <el-option
                v-for="bank in data.bankList"
                :key="bank.mcode"
                :label="bank.name"
                :value="bank.mcode"
                >{{ bank.name }}</el-option
              >
            </el-select>
          </div>
          <!-- //은행 선택 -->

          <!-- 계좌번호 -->
          <div class="bank-wrap account input-box authID mt8">
            <div class="name">
              {{ $t("Verification.step4.korean.accountNumber.title") }}
            </div>
            <el-input
              type="number"
              pattern="\d*"
              v-model="data.bankAccount"
              :placeholder="
                $t('Verification.step4.korean.accountNumber.description')
              "
              :disabled="data.success"
              class="en-name account"
              @input="checkAccountsNumber(data.bankAccount)"
            ></el-input>
            <!-- 
              :class="{
                wrongData:
                  data.bankAccount.length < 8 ||
                  data.bankAccount.length > 15 ||
                  checkAccounts == false,
              }" -->
            <div
              v-if="data.bankAccount.length < 8 || data.bankAccount.length > 15"
              class="sub keyColor mt4 fs10"
            >
              * {{ $t("Verification.step4.korean.accountNumber.noti") }}
            </div>
          </div>
          <!-- //계좌번호 -->

          <!-- 계좌명 -->
          <div v-if="data.success" class="bank-wrap confirm mt8" flex>
            <div class="name">
              {{ $t("Verification.step4.korean.accountName.title") }}
            </div>
            <div class="user-name">{{ data.bankName }}</div>
          </div>
          <!-- //계좌명 -->

          <!-- 다른 은행 선택 버튼 -->
          <div v-if="data.success" class="button-wrap">
            <div @click="reset" class="button" flex>
              <div class="text-wrap txt-block">
                <p>{{ $t("Verification.step4.korean.selectOthers.title") }}</p>
                <img
                  src="../../../../../../assets/img/mypage/Bank_check_ic_normal.svg"
                  alt=""
                  class="bank-icon"
                />
              </div>
            </div>
            <div class="bottom-button-wrap mt108 mb32" flex fjb>
              <button @click="toOneForth" class="next-button pre">
                {{ $t("Verification.common.pre") }}
              </button>
              <button
                @click="toSendNumber"
                :disabled="!data.success"
                class="next-button next"
              >
                {{ $t("Verification.common.next") }}
              </button>
            </div>
          </div>

          <!-- //다른 은행 선택 버튼 -->

          <!-- 계좌확인 버튼 -->
          <div v-else class="button-wrap">
            <button
              @click="checkAccountAddress"
              :disabled="
                data.bankAccount.length < 8 || data.bankAccount.length > 16
              "
              class="user-account button"
              flex
            >
              <div class="text-wrap">
                {{ $t("Verification.step4.korean.confirmAccount") }}
                <img
                  src="../../../../../../assets/img/mypage/Bank_check_ic_normal_white.svg"
                  alt=""
                  class="bank-icon"
                />
              </div>
            </button>
            <div class="bottom-button-wrap mt183" flex fjb>
              <button @click="toStep3" class="next-button pre">
                {{ $t("Verification.common.pre") }}
              </button>
              <button disabled class="next-button next">
                {{ $t("Verification.common.next") }}
              </button>
            </div>
          </div>
          <!-- //계좌확인 버튼 -->
        </div>
        <!-- 4-1 -->
      </div>

      <!-- 4-2 -->
      <div v-else-if="data.twoForth" class="pt20">
        <div v-if="data.checkCount > 2" class="top-noti send-money">
          <img
            src="../../../../../../assets/img/mypage/exclamation_mark_ic.svg"
            alt=""
            class="exclamation-mark"
          />
          {{
            "1일 1원 인증 가능 횟수 3회를 모두 소진하였습니다. \n자정(GMT+9) 이후 다시 시도해 주세요."
          }}
        </div>
        <div v-else class="top-noti send-money">
          <img
            src="../../../../../../assets/img/mypage/exclamation_mark_ic.svg"
            alt=""
            class="exclamation-mark"
          />
          {{ data.findBank.name }} ({{ accountMasking(data.bankAccount) }})
          {{ $t("Verification.step4.korean.sendMoney") }}
        </div>
        <div class="content mt12">
          <div>
            {{ $t("Verification.step4.korean.authNumber.noti[0]") }}
            <br />
            <span class="sub-color">
              {{ $t("Verification.step4.korean.authNumber.noti[1]") }}
            </span>
            {{ $t("Verification.step4.korean.authNumber.noti[2]") }}
          </div>
          <div class="send-money mt21">
            <div class="text-sample">
              {{ $t("Verification.step4.korean.example[0]") }}
              <span class="sub-color ml4">***</span>
            </div>
          </div>
          <div class="auth-number mt20" flex fjb>
            <div class="text-height">
              {{ $t("Verification.step4.korean.example[1]") }}
            </div>
            <div class="authID input-box auth-number">
              <!-- 1원 검증 인증번호 -->
              <el-input
                type="number"
                pattern="\d*"
                @input="checkNumberLength"
                autofocus="true"
                v-model="data.authNumberFirst"
                class="en-name sqare"
              ></el-input>
              <!-- // 1원 검증 인증번호 -->
            </div>
          </div>
          <div class="authCountDown mt12 fs16 ta-c">
            {{ $t("Verification.step4.korean.try[0]") }}
            <span class="keycolor"
              >{{ data.checkCount > 2 ? 0 : 2 - data.checkCount
              }}{{ $t("Verification.step4.korean.try[1]") }}</span
            >
          </div>
          <div class="authCountDown mt12 fs16 ta-c">
            <span class="keycolor">
              {{ remain }}
            </span>
          </div>
          <div v-if="data.send" @click="checkCounts" class="button-wrap" flex>
            <div class="button">
              <p>{{ "재인증" }}</p>
            </div>
          </div>
          <div>
            <div class="bottom-button-wrap mt105 mb32" flex fjb>
              <button @click="toOneForthSec" class="next-button pre">
                {{ $t("Verification.common.pre") }}
              </button>
              <button
                :disabled="data.authNumberFirst.length !== 3"
                @click="submit"
                class="next-button next"
              >
                {{ $t("confirm.done") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- //4-2 -->
      <!-- //하단 콘텐츠 -->
    </div>

    <!-- 잘못된 계좌번호 입니다. 팝업 -->
    <vs-popup
      :title="$t('notify.type.info')"
      :button-close-hidden="true"
      :active.sync="data.wrongAccount"
      class="small-popup auth-account"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <p class="center">
            {{ popupErrorMessage }}
          </p>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="data.wrongAccount = false">
          {{ $t("confirm.ok") }}
        </button>
      </div>
    </vs-popup>
    <!-- //잘못된 계좌번호 입니다. 팝업 -->

    <!-- 1원을 정상 이체 팝업 -->
    <vs-popup
      :title="$t('Verification.step4.korean.complete.title')"
      :button-close-hidden="true"
      :active.sync="data.sendMoney"
      class="small-popup auth-account"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <p
            class="center"
            v-html="$t('Verification.step4.korean.complete.description')"
          ></p>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="data.sendMoney = false">{{ $t("confirm.ok") }}</button>
      </div>
    </vs-popup>
    <!-- //1원을 정상 이체 팝업 -->

    <!-- 3회 초과 팝업 -->
    <vs-popup
      :title="$t('notify.type.info')"
      :button-close-hidden="true"
      :active.sync="data.limitAccountModal"
      class="small-popup auth-account"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <p class="center" v-html="$t('Verification.step4.korean.over')"></p>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="data.limitAccountModal = false">
          {{ $t("confirm.ok") }}
        </button>
      </div>
    </vs-popup>
    <!-- //3회 초과 팝업 -->

    <!-- 1원 검증 번호 오류 -->
    <vs-popup
      :title="$t('notify.type.info')"
      :button-close-hidden="true"
      :active.sync="data.wrongAuthNumber"
      class="small-popup auth-account"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <p class="center" v-html="data.wrongAccountMessage"></p>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="authNumberError">
          {{ $t("confirm.ok") }}
        </button>
      </div>
    </vs-popup>
    <!-- //1원 검증 번호 오류 -->
  </div>
</template>
<script>
import Api from "@/common/Api";
import { mapGetters } from "vuex";
import Moment from "moment";

export default {
  components: {},
  props: {
    data: Object,
    step2data: {
      name: String, // 이름
    },
  },
  created() {
    window.scrollTo(0, 0);

    Api.Setting.getBankList().then((response) => {
      const bankList = _.filter(response.body, (bank) => bank.mcode);
      this.data.bankList = bankList;
    });
  },
  data() {
    return {
      onFocusSecond: false,
      onfocus: false,
      popupErrorMessage: "",
      checkAccounts: true,
      remain: "00:00",
      // expire: +Moment().add(5, "seconds"),
      expire: +Moment().add(30, "minutes"),
      beforeData: {},
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    limitNumber() {
      if (this.data.checkCount > 2) {
        return 0;
      } else {
        return this.data.checkCount;
      }
    },
  },
  methods: {
    //input type number 입력수 제한
    checkNumberLength() {
      if (this.data.authNumberFirst.length > 3) {
        this.data.authNumberFirst = this.data.authNumberFirst.slice(0, 3);
      }
    },
    // 기본정보로 이동
    toStep3() {
      this.$emit("tostep3");
    },
    // 4-1로 이동
    toOneForth() {
      this.data.authNumberFirst = "";
      this.data.oneForth = true;
      this.data.twoForth = false;
      this.data.success = false;
    },
    // 4-1로 이동
    toOneForthSec() {
      this.data.authNumberFirst = "";
      this.data.oneForth = true;
      this.data.twoForth = false;
      this.data.success = true;
    },

    // close all
    closeAll() {
      this.$emit("closeall");
    },
    reset() {
      this.data.bankMCode = "";
      this.data.bankAccount = "";
      this.data.bankName = "";
      this.data.changeBank = false;
      this.data.success = false;
    },
    // stage2. 계좌 조회(예금주 성명 조회)
    async checkAccountAddress() {
      console.log("this.data.findBank", this.data.findBank);
      // 은행 정보 (code, name, etc..)
      this.data.findBank = _.find(
        Object.values(this.data.bankList),
        (ele) => ele.mcode === this.data.bankMCode
      );

      this.data.bankCode = this.data.findBank.code;

      const params = {
        // mchtCustId: "2000460",
        // custAcntNo: "123456789",
        // mchtCustNm: "이나리",
        // bankCd: "kdb",
        mchtCustId: String(this.userInfo.uuidx),
        custAcntNo: String(this.data.bankAccount),
        mchtCustNm: String(this.step2data.name),
        bankCd: String(this.data.findBank.code),
      };
      try {
        const res = await Api.User.checkAccountHolder(params); //예금주 성명조회
        if (res.data.result.mchtCustNm !== this.step2data.name) {
          this.popupErrorMessage = this.$t(
            "Verification.step4.korean.notOwner"
          );
          this.data.wrongAccount = true; //계좌번호 불일치 팝업
          this.data.success = false;
        } else {
          this.data.success = true;
          this.data.bankName = res.data.result.mchtCustNm;
        }
      } catch (error) {
        this.popupErrorMessage = this.$t(
          "Verification.step4.korean.wrongNumber"
        );
        this.data.wrongAccount = true; //계좌번호 불일치 팝업
        this.data.success = false;
      }
    },
    // 1원검증, 4-2로 이동
    async toSendNumber() {
      this.data.oneForth = false;
      this.data.twoForth = true;
      this.checkCounts();
    },
    // 1원 송금 횟수 체크
    async checkCounts() {
      try {
        this.data.send = false;

        //1원 검증 횟수 : 0 ~ 2
        const res = await Api.User.registUserAccount();
        this.data.checkCount = res.data.result;
        if (this.data.checkCount > 2) {
          this.data.limitAccountModal = true; // 3회 초과 팝업
        } else {
          // 1원 송금

          // setInterval(() => alert("test"), 1000);
          const beBankCd = this.beforeData.bankCd ? this.beforeData.bankCd : ""; // 이전 전송 은행코드
          const beCustAcntNo = this.beforeData.custAcntNo
            ? this.beforeData.custAcntNo
            : ""; // 이전 전송 은행계좌
          const beforeMergeData = beBankCd + "+" + beCustAcntNo; // 이전 전송 은행코드+은행계좌
          const newMergeData =
            this.data.findBank.code + "+" + this.data.bankAccount; // 현재 전송할 은행코드+은행계좌

          // 이전과 현재 전송할 은행코드+은행계좌 같을 때
          if (beforeMergeData == newMergeData) {
            // 이전 1원 전송 resTime
            if (Moment(this.data.sendMoneyTime).isAfter(Moment())) {
              // 시간 유지

              setInterval(() => {
                Moment(this.data.sendMoneyTime).isBefore(Moment())
                  ? (this.data.send = true)
                  : (this.data.send = false);
              }, 1000);
            } else {
              // 재 카운트
              setInterval(this.remainTime, 1000);
              this.expiredTime();
              this.sendMoney();
              setTimeout(() => {
                this.data.send = true;
                // }, 5000);
              }, 1800000);
            }
          } else {
            // 재 카운트
            setInterval(this.remainTime, 1000);
            this.expiredTime();
            this.sendMoney();
            setTimeout(() => {
              this.data.send = true;
              // }, 5000);
            }, 1800000);
          }
        }
      } catch (error) {
        this.$vs.notify({
          title: "오류",
          text: "test" + error.msg,
          position: "top-right",
          color: "danger",
        });
      }
    },
    // 1원 송금
    async sendMoney() {
      try {
        const params = {
          mchtCustId: String(this.userInfo.uuidx),
          custAcntNo: this.data.bankAccount,
          mchtCustNm: this.step2data.name,
          bankCd: this.data.findBank.code,
        };

        this.data.checkNumberapiData = await Api.User.checkRealUserAccount(
          params
        );

        this.beforeData = params;

        const sendMoneyTime =
          this.data.checkNumberapiData.data.header.responseTime;

        // 1원 송금 api resTime + 30분
        this.data.sendMoneyTime = Moment(sendMoneyTime)
          .add(-9, "hours")
          // .add(5, "seconds");
          .add(30, "minutes");

        this.data.sendMoney = true;
      } catch (error) {
        this.$vs.notify({
          title: "오류",
          text: error.msg,
          position: "top-right",
          color: "danger",
        });
      }
    },
    // 신원인증 심사 안내 팝업
    submit() {
      this.$emit("submit");
    },
    // close all
    closeAll() {
      this.$emit("closeall");
    },
    reset() {
      this.data.bankMCode = ""; // bank name code
      this.data.bankAccount = ""; // 입력계좌
      this.data.bankName = ""; // 계좌명
      this.data.changeBank = false;
      this.data.success = false;
      this.data.bankCode = false; // bank code(숫자)
    },
    // 계좌번호 마스킹 : 7자리부터 적용
    accountMasking(value) {
      const noneMasked = value.slice(0, 6);
      const masked = value.slice(6);
      let masking = "";
      for (var i = 0; i < masked.length; i++) {
        masking = masking + "*";
      }
      return noneMasked + masking;
    },
    // 1원 검증 인증번호 포커스 자동 이동
    moveToSec() {
      this.$refs.numberSec.focus();
    },
    moveToThi() {
      this.$refs.numberThi.focus();
    },
    checkAccountsNumber(value) {
      const checkNum = /^[0-9]$/;
      if (checkNum.test(value) == false) {
        this.checkAccounts = true;
      } else {
        this.checkAccounts = false;
      }
    },
    remainTime() {
      const remain = Moment(+this.expire - +Moment());
      if (+remain > 0) {
        this.remain = remain.format("mm:ss");
      } else {
        this.remain = "00:00";
      }
    },
    expiredTime() {
      // this.expire = +Moment().add(5, "seconds");
      this.expire = +Moment().add(30, "minutes");
      // this.remainTime();
    },
    authNumberError() {
      this.data.wrongAuthNumber = false;
      this.data.authNumberFirst = "";
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0 !important;
}
.defaultColor {
  color: #333;
}
.sub-color {
  color: #00b473;
}
.content-wrap {
  position: relative;
  padding: 12px 12px 0;
  font-size: 12px;
  color: #333;
  .top-wrap {
    // step number
    .step-number {
      .number {
        width: 20px;
        height: 20px;
        text-align: center;
        color: #dcdfe3;
        border-radius: 2px;
        background-color: #f7f8fa;
        &.active {
          color: #fff;
          background-color: #333;
        }
      }
    }
  }
  .top-noti {
    position: relative;
    padding: 17px 36px;
    border-radius: 4px;
    border: solid 1px #dcdfe3;
    background-color: #fff;
    .exclamation-mark {
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
    }
  }
  .content {
    posi .bank-wrap {
      .user-name {
      }
      &.confirm {
        background-color: #dcdfe3;
      }
    }
    .button-wrap {
      position: relative;
      // 라운드 버튼
      .button {
        position: absolute;
        top: 24px;
        left: 50%;
        transform: translateX(-50%);
        width: fit-content;
        height: 54px;
        padding: 15px;
        border-radius: 162px;
        border: solid 1px #dcdfe3;
        background-color: #fff;
        .text-wrap {
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
          justify-items: center;
          color: #dcdfe3;
          &.txt-block {
            color: #333;
          }
        }
        img.bank-icon {
          margin-left: 17px;
        }
        &.user-account {
          color: #fff;
          background-color: #1655a7;
        }
      }
      button.button:disabled {
        background-color: #fff !important;
      }
    }
    .send-money {
      width: 100%;
      padding: 9px 0;
      border-radius: 2px;
      border: solid 1px #dcdfe3;
      background-color: #f7f8fa;
      .text-sample {
        width: fit-content;
        margin: 0 auto;
      }
    }
    .auth-number {
      line-height: 72px;
    }
  }

  // 하단 버튼
  button.next-button {
    width: 100%;
    padding: 10px 0;
    font-size: 12px;
    border-radius: 2px;
    border: 1px solid #00b473;
    background-color: #00b473;
    &.pre {
      width: 96px;
      color: #333;
      border: 1px solid #eeeeee;
      background-color: #fff;
      &:disabled {
        border: solid 1px #dadada !important;
        background-color: #dadada !important;
      }
    }
    &.next {
      width: calc(100% - 104px);
    }
    &.bottom {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 24px);
    }
    &:disabled {
      border: solid 1px #dadada !important;
      background-color: #dadada !important;
    }
  }
  .bottom-button-wrap {
    width: 100%;
  }
}
</style>
